import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { ExtraCampaignsServiceProvider } from '../../api/extra-campaigns'

const ExtraCampaignsService = ExtraCampaignsServiceProvider()
const name = 'codesResetAlternativeCampaign'

export default (id) => (asyncAction(
  name,
  ExtraCampaignsService.codesResetAlternativeCampaign,
  { id }
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/extra-campaign/codesResetAlternativeCampaign.js